// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MEpq","title":"styles_title__j5iJI"};